export default __webpack_public_path__ + "static/media/redlightLogo.50c6bcc9.png";